import { useEffect, useState } from "react"
import API from "../../../services/API"
import Layout from "../../Frames/Layout"
import Grid from "../../Tools/Grid";
import { Link as A, Button, IconButton } from "@mui/material";
import { Link } from "react-router-dom";
import { Add, ContentCopy, Delete, Edit, ZoomIn } from "@mui/icons-material";
import moment from "moment";
import {CopyToClipboard} from 'react-copy-to-clipboard';
import Toast from "../../Tools/Toast";

export default function Actions(){

    const columns = [
        {
            field: 'title',
            headerName: 'Titre',
            width: 340,
            valueGetter: p => p.row.title
        },
        {
            field: 'media',
            headerName: 'Media',
            width: 100,
            valueGetter: p => p.row.media?.title
        },
        {
            field: 'conversions',
            headerName: 'Conversions',
            width: 100,
            align: "center",
            valueGetter: p => p.row.id,
            renderCell: p => !p.rowNode.isAutoGenerated && 
                <IconButton 
                    size="small"
                    component={Link}
                    to={`/marketing/sticker/actions/${p.value}/conversions`}
                >
                    <ZoomIn />
                </IconButton>
        },
        {
            field: 'trackingUrl',
            headerName: 'URL de tracking',
            width: 540,
            valueGetter: p => p.row.trackingUrl
        },
        {
            field: 'copy',
            headerName: 'Copier',
            width: 60,
            valueGetter: p => p.row.trackingUrl,
            renderCell: p => !p.rowNode.isAutoGenerated && 
                <CopyToClipboard text={p.value} onCopy={() => setToast({s: 'success', m: "Le lien a été copié dans le presse-papiers"})}>
                    <IconButton size='small'>
                        <ContentCopy />
                    </IconButton>
                </CopyToClipboard>
        },
        {
            field: 'targetUrl',
            headerName: 'URL cible',
            width: 600,
            valueGetter: p => p.row.targetUrl,
            renderCell: p => <A href={p.value} target="_blank" rel="noopener noreferrer">{p.value}</A>
        },
        {
            field: 'shipments',
            headerName: 'Envois',
            width: 60,
            type: 'number',
            valueGetter: p => p.row.shipments
        },
        {
            field: 'clicks',
            headerName: 'Clics',
            width: 60,
            type: 'number',
            valueGetter: p => p.row.clicks
        },
        {
            field: 'newAccounts',
            headerName: 'Comptes créés',
            width: 120,
            type: 'number',
            valueGetter: p => p.row.newAccounts
        },
        {
            field: 'enrollments',
            headerName: 'Inscriptions',
            width: 100,
            type: 'number',
            valueGetter: p => p.row.enrollments
        },
        {
            field: 'value',
            headerName: 'Valeur €',
            width: 100,
            type: 'number',
            valueGetter: p => p.row.value
        },
        {
            field: 'teacher',
            headerName: 'Formateur',
            width: 200,
            valueGetter: p => (p.row.teacher?.name || p.row.teacher?.email),
            renderCell: p => !p.rowNode.isAutoGenerated && 
                (p.row.teacher?.id ? 
                    <Link to={`/crm/persons/${p.row.teacher?.id}`}>
                        <A component='span'>{p.value}</A>
                    </Link>    
                    : p.row.teacher?.email
                )
        },
        {
            field: 'tags',
            headerName: 'Mots clés',
            width: 200,
            valueGetter: p => p.row.tags
        },
        {
            field: 'createdAt',
            headerName: 'Créé le',
            width: 95,
            valueGetter: p => moment(p.row.createdAt).toDate(),
            renderCell: p => !p.rowNode.isAutoGenerated && 
                moment(p.row.createdAt).format('DD/MM/YYYY')
        },
        {
            field: 'edit',
            headerName: '',
            width: 60,
            valueGetter: p => p.row.id,
            renderCell: p => !p.rowNode.isAutoGenerated && 
                <Link to={`/marketing/sticker/actions/${p.value}`}>
                    <IconButton size='small'>
                        <Edit />
                    </IconButton>
                </Link>
        },
        {
            field: 'delete',
            headerName: '',
            width: 60,
            valueGetter: p => p.row.id,
            renderCell: p => !p.rowNode.isAutoGenerated && 
                <IconButton size='small' onClick={() => handleDelete(p.value)}>
                    <Delete />
                </IconButton>
        },
    ];

    const [items, setItems] = useState(null)

    const [toast, setToast] = useState(null)

    useEffect(() => {

        API.get('/sticker/actions')
            .then(r => setItems(r.data))
    }, [])


    const handleDelete = id => {
        const ok = window.confirm("Êtes-vous sûr de vouloir supprimer cette action ?");

        if(!ok) return false;

        const old = [...items];

        API.delete(`/sticker/actions/${id}`)
            .catch(() => setItems(old))

        setItems([...items].filter(i => i.id !== id))

        setToast({s: 'success', m: "L'action a bien été supprimée"})
    }



    return <Layout title="Pixel LearnyLib" menu="marketing" tab="sticker">

        <Link to="/marketing/sticker/actions/new">
            <Button startIcon={<Add />} variant='contained' sx={{mb: 1}}>
                Ajouter
            </Button>
        </Link>
    
        <Grid 
            id='stickerActionsGrid'
            columns={columns}
            rows={items}
            toolbar
            aggregate={{clicks: 'sum', newAccounts: 'sum', enrollments: 'sum', value: 'sum'}}
        />

        <Toast 
            open={toast ? true : false}
            duration={4000}
            severity={toast?.s}
            message={toast?.m}
            onClose={() => setToast(false)}
        />

    </Layout>
}